import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import ExploreMotionButton from "./ExploreMotionButton";
import DashboardNotificationDropdown from "./DashboardNotificationDropdown";
import DashboardProfileDropdown from "./DashboardProfileDropdown";
import { navigateToExploreMotion } from "../../DashboardLayout/dashboardNavigation";
import "./DashboardHeaderActions.css";

const DashboardHeaderActions = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <div className="dashboard-header-actions">
      <ExploreMotionButton
        onClick={() => navigateToExploreMotion(history, dispatch)}
      />

      <div className="dashboard-header-actions__utilities">
        <DashboardNotificationDropdown />
        <DashboardProfileDropdown />
      </div>
    </div>
  );
};

export default DashboardHeaderActions;

